import { faAlignLeft, faAlignRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"


function ResponseTextView({body}) {
  return (
    <>
        <textarea readOnly
                    className={`form__input  form__input--body  `}
                    id="body"
                    name="body"
                    value={body}
                    
                />        
           
    </>
   
  )
}

export default ResponseTextView